<template>
   <div class="container container-footer bg-gray" :class="{ 'container-nav': !isMiniProgram }">
    <van-nav-bar v-if="!isMiniProgram" title="我的财富" fixed :border="false" :z-index="999" class="nav-bar-primary" @click-left="goBack" />
    <van-pull-refresh v-model="refreshing" @refresh="getYearBill(true)" class="bill-van-pull">
      <section class="bill-box bg-white txt-c">
        <p class="f16 f-b">累计收入</p>
        <h2 class="c-orange f-b f36 mb10 mt16">{{ total.amount | formatFixed2 }}</h2>
        <div class="f15"><span class="nopay">未发放<span class="c-orange f-b">
              {{ total.unpaidAmount | formatFixed2 }} </span>元</span>
        </div>
        <van-row type="flex" justify="center" class="mt28">
          <van-col span="12">
            <p class="c-gray f12">佣金(元)</p>
            <p class="f-b f16 mt5">{{ total.commission | formatFixed2 }}</p>
          </van-col>
          <van-col span="12">
            <p class="c-gray f12">下级队长贡献(元)</p>
            <p class="f-b f16 mt5">{{ total.subVleaderCommission | formatFixed2 }}</p>
          </van-col>
        </van-row>
      </section>
      <h5 class="income-title"><span style="display: inline-block;margin-right: 8px; vertical-align: middle;"><img src="../../assets/images/mybill/billicon.png" width="25px"/></span>收益明细</h5>
      <div v-if="billList.length === 0" class="empty">暂无明细</div>
      <van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadMore">
        <section v-for="(item, index) in billList" :key="index" class="bill-box bg-white txt-c bill-details"
          @click="goToDetail(item)">
          <div class="month-label c-gray">
            {{ item.monthStr }}
            <van-icon v-if="!item.accounting" name="question-o" @click.stop="showTip"
              style="margin-left: 5px; color: #999;" />
          </div>
          <div v-if="!item.accounting">
            <div class="settlement-row">
              <div class="settlement-item">
                <span>已结算：</span>
                <span class="c-orange">{{ item.amount | formatFixed2 }}</span>
              </div>
              <div class="settlement-item">
                <span>已发放：</span>
                <span class="c-orange">{{ item.releaseAmount | formatFixed2 }}</span>
              </div>
            </div>
            <van-row type="flex">
              <van-col span="12">
                <p class="c-gray f12">佣金(元)</p>
                <p class="f-b f16 mt5">{{ item.commission | formatFixed2 }}</p>
              </van-col>
              <van-col span="12">
                <p class="c-gray f12">下级队长贡献(元)</p>
                <p class="f-b f16 mt5">{{ item.subVleaderCommission | formatFixed2 }}</p>
              </van-col>
            </van-row>
          </div>
          <div v-else>
            <h4>核算中<span class="dotting"></span></h4>
          </div>
        </section>
      </van-list>
    </van-pull-refresh>

    <!-- 首次打款签约弹框 -->
    <van-dialog v-model="showSignPopup" :show-confirm-button="false" :show-cancel-button="false" class="sign-dialog">
      <div class="sign-dialog-content">
        <div class="sign-dialog-header">
          <span class="sign-dialog-title">首次打款签约</span>
          <span class="icon icon-help sign-help-icon" @click="showSignTip = !showSignTip"></span>
          <div class="sign-tip-popup" v-show="showSignTip">
            <div class="sign-tip-content">本次签约用于推荐结算、打款核验以及确认合作关系，请点击签约完成签约方便平台打款，如未完成签约则平台将不会结算推荐费用。</div>
            <span class="sign-tip-arrow"></span>
          </div>
        </div>
        <div class="sign-dialog-body">
          为顺利完成打款到账及履行相应税务申报义务，首次打款前请进行签约。
        </div>
      </div>
      <div class="sign-dialog-footer">
        <van-button class="sign-btn sign-btn-cancel" @click="onSignCancel">取消</van-button>
        <van-button class="sign-btn sign-btn-confirm" @click="onSignConfirm">去签约</van-button>
      </div>
    </van-dialog>
    <tab-bar />
  </div>
</template>

<script>
import tabBar from '../../components/tab-bar';
import api from '../../api';
import { getEnv } from '../../libs/util';
export default {
  name: 'my-bill',
  components: { tabBar },
  data() {
    return {
      total: {
        amount: 0,//累计收入
        unpaidAmount: 0,//未发放
        commission: 0, //佣金
        subVleaderCommission: 0//下级队长贡献
      },
      billList: [],
      units: [],
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      refreshing: false,
      showSignPopup: false,
      showSignTip: false,
      remarks: ['<p>由于考勤工时计算有一定滞后性，此处为预估金额，实际收入以结算金额为准。</p>',
        '<p class="f-b">拉新规则：</p>' +
        '<p>在平台首次入职且工作满5小时，每拉新一人奖励50元</p>' +
        '<p class="pt8 f-b">拉新额外奖励规则：</p>' +
        '<p>满5人可额外奖励300元</p>' +
        '<p>满10人可额外奖励500元</p>' +
        '<p>满15人可额外奖励800元</p>' +
        '<p class="pt8">注：额外奖励只能对应一个</p>',
        '<p>工时满1000小时整体佣金收益将提高20%</p>' +
        '<p class="pt8">工时满2000小时整体佣金收益将提高50%</p>' +
        '<p class="pt8">工时满3000小时整体佣金收益将提高100%</p>',
        '<p>下级微领队佣金奖励的15%</p>'],
    };
  },
  computed: {
    isMiniProgram() {
      return getEnv().envType === 'miniprogram';
    }
  },
  mounted() {
    this.getYearBill();
    this.checkContractNeedSign();
  },
  methods: {
    async checkContractNeedSign() {
      try {
        const res = await api.get('/api/vpai/vleader/contract/checkContractNeedSign');
        if (res.code === 10000 && res.data) {
          const { hasIncome, needSign } = res.data;
          // 有收入且需要签约时弹出提示
          if (hasIncome && needSign) {
            this.showSignDialog();
          }
        }
      } catch (e) {
        console.error('检查签约状态失败', e);
      }
    },
    showSignDialog() {
      this.showSignPopup = true;
      this.showSignTip = false;
    },
    onSignConfirm() {
      this.showSignPopup = false;
      this.goToSign();
    },
    onSignCancel() {
      this.showSignPopup = false;
      this.showCancelConfirmDialog();
    },
    showCancelConfirmDialog() {
      this.$dialog.confirm({
        title: '取消',
        message: '本次签约用于推荐结算、打款核验以及确认合作关系，请点击签约完成签约方便平台打款，如未完成签约则平台将不会结算推荐费用。',
        confirmButtonText: '去签约',
        cancelButtonText: '仍要取消',
        confirmButtonColor: '#FF6400'
      }).then(() => {
        // 点击去签约
        this.goToSign();
      }).catch(() => {
        // 点击仍要取消，关闭弹窗
      });
    },
    async goToSign() {
      // TODO: 跳转到签约页面，根据实际路由修改
      try {
        const env = getEnv();
        // 只传路径，后端根据 sourceType 自己拼接完整的 redirectUrl
        const redirectPath = '/my-bill';
        // 根据环境确定来源标识
        let sourceType = 'H5';
        if (env.envType === 'app') {
          sourceType = 'JybApp';
        } else if (env.envType === 'miniprogram') {
          sourceType = 'WxMini';
        }

        console.log('签约环境:', env.envType, '回调路径:', redirectPath, 'sourceType:', sourceType);

        const result = await api.get('/api/vpai/vleader/sign_contract', {
          params: {
            redirectUrl: redirectPath,
            sourceType: sourceType
          }
        });

        if (result.code === 10000 && result.data && result.data.signUrl) {
          // 跳转到签约页面
          location.href = result.data.signUrl;
        } else {
          this.$error(result.message || '获取签约链接失败');
          setTimeout(() => {
            this.goBack();
          }, 1000);
        }
      } catch (e) {
        this.$error(e.message || '获取签约链接失败');
        setTimeout(() => {
          this.goBack();
        }, 1000);
      }
    },
    async getYearBill(isRefresh = false) {
      console.log('获取我的账单列表');
      try {
        if (isRefresh) {
          this.refreshing = true;
          this.pageNum = 1;
          this.billList = [];
          this.finished = false;
        } else {
          this.$loading();
        }
        const res = await this.$store.dispatch('getData', {
          url: '/api/vpai/vleader/statistics/monthly'
        });
        if (res) {
          console.log('获取我的账单数据:', res);
          if (res.total) {
            this.total.amount = res.total.amount;
            this.total.unpaidAmount = res.total.unpaidAmount;
            this.total.commission = res.total.commission;
            this.total.subVleaderCommission = res.total.subVleaderCommission;
          }
          if (res.units) {
            this.units = res.units;
            this.billList = this.units.slice(0, this.pageSize);
            this.finished = this.units.length <= this.pageSize;
          }
        }
        this.refreshing = false;
        this.$loadingClose();
      } catch (e) {
        this.$error(e.message);
        this.refreshing = false;
      }
    },
    async loadMore() {
      try {
        this.loading = true;
        const start = (this.pageNum - 1) * this.pageSize;
        const end = this.pageNum * this.pageSize;
        const newData = this.units.slice(start, end).map(item => ({
          monthStr: item.monthStr,
          amount: item.amount,
          releaseAmount: item.releaseAmount,
          commission: item.commission,
          subVleaderCommission: item.subVleaderCommission,
          accounting: item.accounting
        }));
        this.billList.push(...newData);
        this.pageNum++;
        if (end >= this.units.length) {
          this.finished = true;
        }
        this.loading = false;
      } catch (e) {
        this.$error(e.message);
        this.loading = false;
      }
    },
    showTip() {
      this.$toast('由于考勤工时未完全核算完，金额会有变动。');
    },
    goToDetail(item) {
      this.$router.push({ path: '/my-bill-detail', query: { month: item.monthStr } });
    }
  }
};
</script>

<style lang="less">
@import '../../assets/css/theme.less';

.nopay {
  border-radius: 20px;
  padding: 10px 20px;
  background: #f8f8f8;
}

.bill-box {
  padding: 30px 20px;
  margin: 15px;
  border-radius: 5px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
}

.pay-title {
  background: #f8f8f8;
  padding: 8px 0 8px 10px;
}

.bill-img {
  width: 18px;
  height: 18px;
  margin-right: 3px;
}

.bill-refect-tip {
  left: 127px;
  z-index: 10;
}

.dotting {
  display: inline-block;
  width: 10px;
  min-height: 2px;
  padding-right: 2px;
  border-left: 2px solid currentColor;
  border-right: 2px solid currentColor;
  background-color: currentColor;
  background-clip: content-box;
  box-sizing: border-box;
  animation: dot 2s infinite step-start both;
}

.dotting::before {
  content: '';
}

:root .dotting {
  margin-left: 2px;
  padding-left: 2px;
}

@keyframes dot {
  25% {
    border-color: transparent;
    background-color: transparent;
  }

  /* 0个点 */
  50% {
    border-right-color: transparent;
    background-color: transparent;
  }

  /* 1个点 */
  75% {
    border-right-color: transparent;
  }

  /* 2个点 */
}

.bill-van-pull {
  min-height: calc(100vh - 45px);
}

.income-title {
  font-size: 18px;
  padding-left: 20px;
}

.bill-details {
  padding: 10px 15px;
}

.month-label {
  text-align: left;
  margin-bottom: 15px;
}

.settlement-row {
  display: flex;
  margin: 0 auto 15px auto;
}

.settlement-item {
  flex: 1;
}

.empty {
  text-align: center;
  padding: 50px 0;
  color: #999;
}


/* 签约弹框样式 */
.sign-dialog {
  border-radius: 5px;
  overflow: visible;
}

.sign-dialog-content {
  padding: 20px 20px 0;
}

.sign-dialog-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.sign-dialog-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.sign-help-icon {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: #999;
  cursor: pointer;
}

.sign-tip-popup {
  position: absolute;
  bottom: 30px;
  right: -10px;
  z-index: 100;
  width: 220px;
}

.sign-tip-arrow {
  display: block;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-top-color: #333;
  margin-left: auto;
  margin-right: 15px;
  margin-top: -2px;
}

.sign-tip-content {
  background: #333;
  color: #fff;
  font-size: 12px;
  line-height: 1.6;
  padding: 10px;
  border-radius: 5px;
}

.sign-dialog-body {
  font-size: 12px;
  color: #666;
  line-height: 1.6;
  text-align: center;
  padding: 0 6px 10px;
}

.sign-dialog-footer {
  display: flex;
  border-top: 1px solid #ebedf0;
}

.sign-btn {
  flex: 1;
  height: 48px;
  border-radius: 5px;
  font-size: 16px;
  background: #fff;
  border: none;
}

.sign-btn-cancel {
  color: #323233;
  border-right: 1px solid #ebedf0;
}

.sign-btn-confirm {
  color: #FF6400;
}
</style>
